import firebase from 'firebase/app';
import 'firebase/database';
import { firebaseConfig } from './firebase-config';

let initializePromise = null;

export const ensureFirebaseInitialized = () => {
  if (initializePromise) {
    return initializePromise;
  }

  initializePromise = (async () => {
    try {
      if (firebase.apps && firebase.apps.length > 0) {
        return true;
      }
      firebase.initializeApp(firebaseConfig);
      return true;
    } catch (error) {
      const message = (error && error.message) || String(error);
      if (message.indexOf('already exists') !== -1) {
        return true;
      }
      console.warn('[Firebase] initializeApp failed; continuing without Firebase', {
        error: message,
      });
      return false;
    }
  })();

  return initializePromise;
};

export const getFirebaseApp = () => {
  try {
    if (firebase.apps && firebase.apps.length > 0) {
      return firebase.app();
    }
  } catch (error) {
    return null;
  }
  return null;
};

export const resetFirebaseStateForTests = () => {
  initializePromise = null;
};
